/**
 * Texte ramené à une forme comparable : minuscules, sans accents, séparateurs
 * (tirets, soulignés, espaces multiples) réduits à un espace. « Concrétion-
 * humide-1 » se trouve ainsi en tapant « concretion humide ».
 */
export function normalizeSearchText(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[-_\s]+/g, " ")
    .trim();
}

/**
 * Le texte contient-il tous les mots de la recherche, dans n'importe quel
 * ordre ? Une recherche vide correspond à tout.
 */
export function matchesSearch(text: string, query: string): boolean {
  const words = normalizeSearchText(query).split(" ").filter(Boolean);
  if (!words.length) return true;
  const haystack = normalizeSearchText(text);
  return words.every((word) => haystack.includes(word));
}
